/**
 * @generated SignedSource<<bf13b4996cb8c3b5195d2db9da911331>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InteriorsLandingDesignerItem_designer$data = {
  readonly designFirm: {
    readonly directoryProfile: {
      readonly profilePhoto: string | null;
    } | null;
    readonly name: string | null;
    readonly publicProfile: {
      readonly urlLabel: string | null;
    } | null;
    readonly serviceId: string | null;
  } | null;
  readonly imageUrl: string | null;
  readonly " $fragmentType": "InteriorsLandingDesignerItem_designer";
};
export type InteriorsLandingDesignerItem_designer$key = {
  readonly " $data"?: InteriorsLandingDesignerItem_designer$data;
  readonly " $fragmentSpreads": FragmentRefs<"InteriorsLandingDesignerItem_designer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InteriorsLandingDesignerItem_designer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DirectoryDesignFirm",
      "kind": "LinkedField",
      "name": "designFirm",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DesignFirmDirectoryProfile",
          "kind": "LinkedField",
          "name": "directoryProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profilePhoto",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DesignFirmPublicProfile",
          "kind": "LinkedField",
          "name": "publicProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlLabel",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    }
  ],
  "type": "InteriorsLandingModuleItem",
  "abstractKey": null
};

(node as any).hash = "f0907d23cac7cc918e888eb685ded5bd";

export default node;
